import { SendOutlined, CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { Button, Col, Form, Row, Space, Tag, Radio, Table } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { Links } from '../../helpers/Links';
import { dateCommon, validateMessages } from '../../helpers/common';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { Input } from 'antd/lib';
import { duyetDangKyNgoaiGio, duaYKienDonNgoaiGio, layDanhSachDonNgoaiGioChoPheDuyet } from '../../services/ngoaigio';
import { DonNgoaiGio } from '../../models/ngoaigio/DonNgoaiGio';
import Column from 'antd/es/table/Column';
import { Link } from 'react-router-dom';
import { trangThaiDonNgoaiGio } from '../../constants';

const PheDuyetThemGioTrangChu = () => {
    const { TextArea } = Input;
    const dispatch = useDispatch();
    const [openModalTuChoi, setOpenModalTuChoi] = useState(false);
    const [openModalDuyet, setOpenModalDuyet] = useState(false);
    const [reload, setReload] = useState(false);
    const [lyDoTuChoi, setLyDoTuChoi] = useState<string>("");
    const [formDuaYKien] = useForm();
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [openModalYKien, setOpenModalYKien] = useState(false);
    const [dsThemGio, setDsThemGio] = useState<Array<DonNgoaiGio>>([]);
    const [idDonThemGio, setIdDonThemGio] = useState<number>(0);

    const layDsDuyetThemGio = async () => {
        var dataThemGio = await layDanhSachDonNgoaiGioChoPheDuyet();
        setDsThemGio(dataThemGio.map((item: any, index: any) => {
            return { ...item, key: index }
        }));
    }

    useEffect(() => {
        layDsDuyetThemGio();
    }, []);

    useEffect(() => {
        if (reload) {
            layDsDuyetThemGio();
            setReload(false);
        }
    }, [reload]);

    const onDuaYKien = async () => {
        formDuaYKien.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            try {
                await duaYKienDonNgoaiGio({
                    id: idDonThemGio,
                    isDuyet: values.duyet,
                    noiDung: values.noiDung || ""
                });
                toast.success("Đưa ý kiến thành công.");
                setIdDonThemGio(0);
                setReload(true);
            } catch (ex: any) {
                toast.error(ex);
            }

            dispatch(hideLoadingScreen());
        }).catch(() => {

            dispatch(hideLoadingScreen());
        })
    }

    const eventPheDuyet = async (duyet: boolean) => {
        try {
            await duyetDangKyNgoaiGio({
                id: idDonThemGio,
                isDuyet: duyet,
                noiDung: lyDoTuChoi
            });
            toast.success("Phê duyệt đơn thêm giờ thành công.");
            setIdDonThemGio(0);
            setReload(true);
        } catch (error: any) {
            toast.error(error);
        }
    }

    return (
        <>
            {openModalDuyet && <ModalTextForm show={openModalDuyet}
                title="Đồng ý phê duyệt đơn thêm giờ"
                handleClose={() => {
                    setIdDonThemGio(0);
                    setOpenModalDuyet(false)
                }}
                handleSave={() => { eventPheDuyet(true); setOpenModalDuyet(false); }}>
                <Row>
                    <Col span="24">
                        Bạn có muốn <label>Đồng ý </label> phê duyệt đơn thêm giờ đang chọn không? Hãy nhập nội dung (nếu có):
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <TextArea rows={2} value={lyDoTuChoi} onChange={(e) => { setLyDoTuChoi(e.target.value); }} />
                    </Col>
                </Row>
            </ModalTextForm>}
            {openModalTuChoi && <ModalTextForm show={openModalTuChoi}
                title="Từ chối phê duyệt đơn thêm giờ"
                handleClose={() => {
                    setIdDonThemGio(0);
                    setOpenModalTuChoi(false)
                }}
                handleSave={() => { eventPheDuyet(false); setOpenModalTuChoi(false); }}>
                <Row>
                    <Col span="24">
                        Bạn có muốn <label>Từ chối</label> phê duyệt đơn thêm giờ đang chọn không? Hãy nhập lý do (nếu có):
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <TextArea rows={2} value={lyDoTuChoi} onChange={(e) => { setLyDoTuChoi(e.target.value); }} />
                    </Col>
                </Row>
            </ModalTextForm>}
            {openModalYKien && <ModalTextForm show={openModalYKien}
                title="Đưa ý kiến cho đơn thêm giờ"
                handleClose={() => {
                    setIdDonThemGio(0);
                    setOpenModalYKien(false)
                }}
                handleSave={() => { onDuaYKien(); setOpenModalYKien(false); }}>
                <Form
                    form={formDuaYKien}
                    onFinish={() => { }}
                    validateMessages={validateMessages}
                >
                    <Form.Item label="Ý kiến" name="duyet" rules={[{ required: true }]}>
                        <Radio.Group>
                            <Radio value={true}>Đồng ý</Radio>
                            <Radio value={false}>Từ chối</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        label="Nội dung ý kiến"
                        name="noiDung"
                    >
                        <TextArea placeholder="Nội dung" />
                    </Form.Item>
                </Form>
            </ModalTextForm>}
            <Col xs={24} xl={24}>
                <Row style={{ marginBottom: "12px" }}>
                    <Col span="20">
                        <Row><b style={{ fontSize: "20px", color: "#071C50" }}>Đơn thêm giờ chờ phê duyệt/ ý kiến</b></Row>
                    </Col>
                </Row>
                <Row>
                    <div className="card" style={{ width: "100%" }}>
                        <Table
                            pagination={false}
                            size="small"
                            loading={isLoadingTable}
                            locale={{ emptyText: "Không có dữ liệu" }}
                            dataSource={dsThemGio}
                            rowClassName={(record, index) => {
                                return (record?.id === idDonThemGio) ? "selected-row row-key-" : "";
                            }}
                        >
                            <Column
                                align="center"
                                title="STT"
                                key="STT"
                                width="46px"
                                render={(value, record: any, index) => (
                                    <>{index + 1}</>
                                )}
                            />
                            <Column
                                title="Nhân viên"
                                key="hoTen"
                                render={(value, record: any, index) => {
                                    return <Link
                                        style={{ fontWeight: "bold" }}
                                        to={Links.NgoaiGio.Xem + "?id=" + record.id}
                                    >
                                        {record.tenNhanVien}
                                    </Link>
                                }}
                            />
                            <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" />
                            <Column align="center" title="Ngày" width="100px" dataIndex="ngay" key="ngay" render={(value: any, record: any) => {
                                return dateCommon.formatDate(value, "dd/MM/yyyy");
                            }} />
                            <Column title="Số giờ" align="center" width="60px" dataIndex="soGio" key="soGio" />
                            <Column title="Lý do" dataIndex="lyDo" key="lyDo" />
                            <Column align="center" title="Trạng thái" width="120px" dataIndex="trangThai" key="trangThai" render={(value, record: any) => {
                                var tag = (<Link  to={Links.NgoaiGio.Xem + "?id=" + record.id}></Link>);
                                switch (value) {
                                    case trangThaiDonNgoaiGio.khoiTao: tag = (<Link  to={Links.NgoaiGio.Xem + "?id=" + record.id}><Tag color="processing">Khởi tạo</Tag></Link>); break;
                                    case trangThaiDonNgoaiGio.trinh: tag = (<Link  to={Links.NgoaiGio.Xem + "?id=" + record.id}><Tag color="warning">Trình Lãnh đạo</Tag></Link>); break;
                                    case trangThaiDonNgoaiGio.daDuyet: tag = (<Link  to={Links.NgoaiGio.Xem + "?id=" + record.id}><Tag color="success">Đã Duyệt</Tag></Link>); break;
                                    case trangThaiDonNgoaiGio.tuChoi: tag = (<Link  to={Links.NgoaiGio.Xem + "?id=" + record.id}><Tag color="error">Từ chối</Tag></Link>); break;
                                    case trangThaiDonNgoaiGio.yKien: tag = (<Link  to={Links.NgoaiGio.Xem + "?id=" + record.id}><Tag color="orange">Lấy ý kiến</Tag></Link>); break;
                                    case undefined: tag = (<></>);
                                }
                                return tag;
                            }} />
                            <Column align="center" width="120px" dataIndex="trangThai" key="thaotac" render={(value, record: any) => {
                                var btn = (<Space></Space>);
                                switch (value) {
                                    case trangThaiDonNgoaiGio.trinh: btn = (<Space >
                                        <Button size="small" type="primary" className="float-right hrm-btn-delete" htmlType="button" icon={<CloseOutlined rev="" />}
                                            onClick={() => {
                                                setIdDonThemGio(record.id);
                                                setLyDoTuChoi("");
                                                setOpenModalTuChoi(true);
                                            }}
                                        >
                                            Không duyệt
                                        </Button>
                                        <Button size="small" type="primary" className="float-right" htmlType="button" icon={<CheckOutlined rev="" />}
                                            onClick={() => {
                                                setIdDonThemGio(record.id);
                                                setLyDoTuChoi("");
                                                setOpenModalDuyet(true);
                                            }}>
                                            Duyệt
                                        </Button>
                                    </Space>); break;
                                    case trangThaiDonNgoaiGio.yKien:
                                        btn =
                                            <Button
                                                size="small"
                                                type="primary"
                                                icon={<SendOutlined rev="" />}
                                                onClick={() => {
                                                    setIdDonThemGio(record.id);
                                                    formDuaYKien.setFieldValue('duyet', true);
                                                    formDuaYKien.setFieldValue('noiDung', "");
                                                    setOpenModalYKien(true);
                                                }}
                                            >
                                                Đưa ý kiến
                                            </Button>; break;
                                    default: break;
                                }
                                return btn;
                            }} />
                        </Table>
                    </div>
                </Row>
            </Col>
        </>
    );
};

export default PheDuyetThemGioTrangChu;
